import { ChangeEventHandler, ReactElement, useContext } from "react";
import { Dialog, Button } from "@justworkshr/milo-core";

import {
  REMOVE_METHOD_MODAL_TITLE,
  MATCHING_PHONE_NUMBER_WARNING_JSX,
} from "../copy/removeFactorModalCopy";
import {
  removeFactorMessage,
  GENERAL_ERROR,
} from "global-components/mfa/constants/pageAlertsCopy";

import { Factor } from "types/factor/factor";

import PageAlertContext from "contexts/PageAlertContext";

import useDeleteFactor from "hooks/useDeleteFactor";

type RemoveFactorModalProps = {
  showPhoneWarning: boolean;
  factor: Factor;
  onComplete: () => void;
};

const RemoveFactorModal = ({
  showPhoneWarning,
  factor,
  onComplete,
}: RemoveFactorModalProps): ReactElement => {
  const { mutate: deleteFactor, isLoading } = useDeleteFactor();
  const { setAlert } = useContext(PageAlertContext);

  const handleClickRemove: ChangeEventHandler<HTMLButtonElement> = () =>
    deleteFactor(
      { factorId: factor.id || "" },
      {
        onSuccess: () =>
          setAlert({
            message: removeFactorMessage(factor.key),
            color: "additive",
          }),
        onError: () =>
          setAlert({
            message: GENERAL_ERROR,
            color: "destructive",
          }),
        onSettled: () => onComplete(),
      },
    );

  return (
    <Dialog
      isOpen={true}
      onClose={onComplete}
      title={REMOVE_METHOD_MODAL_TITLE}
      showCloseButton={false}
      primaryButton={
        <Button
          variant="outlined"
          color="destructive"
          loading={isLoading}
          onClick={handleClickRemove}
        >
          Remove
        </Button>
      }
      secondaryButton={
        <Button variant="ghost" onClick={onComplete}>
          Cancel
        </Button>
      }
    >
      {showPhoneWarning && MATCHING_PHONE_NUMBER_WARNING_JSX}
    </Dialog>
  );
};

export default RemoveFactorModal;
